/* eslint-disable react/display-name */
import MultiSelect from "components/lbc-toolkit/molecules/MultiSelect";
import { SelectChangeEvent } from "@mui/material";
import { SelectItem } from "components/molecules/MultiSelectFreeSolo";
import React, { Key, useState } from "react";
import { Empty, ListItem, ListValues, RuleValue } from "react-awesome-query-builder";

interface MultiSelectProps {
  field?: string;
  key?: Key | null | undefined;
  listValues?: ListValues | undefined;
  placeholder?: string;
  setValue?: (val: RuleValue) => void;
  value?: RuleValue | Empty;
}

export default ({ key, placeholder, listValues, setValue, value, field }: MultiSelectProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const renderOptions = ((listValues ?? []) as ListItem[]).reduce<SelectItem[]>(
    (renderOptions: SelectItem[], current: ListItem) => {
      return renderOptions.concat({ label: current?.title ?? "", value: (current?.value as string) ?? "" });
    },
    []
  );

  const handleSelect = (e: SelectChangeEvent<unknown>) => {
    const nextValue = Array.isArray(e.target.value) ? e.target.value : [];
    setValue?.(nextValue as string[]);
    setIsOpen(false);
  };

  const handleDeleteItem = (valueToRemove: string) => {
    const currentValues = [...(value as string[])] as string[];
    const index = currentValues.findIndex((elem: string) => {
      return elem === valueToRemove;
    });
    if (index !== -1) {
      currentValues.splice(index, 1);
      setValue?.(currentValues);
    }
  };
  const handleDeleteAll = () => setValue?.([]);

  return (
    <MultiSelect
      placeholder={placeholder}
      selected={value}
      id="query-builder-multiselect"
      options={renderOptions}
      onChange={handleSelect}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      handleDeleteAll={handleDeleteAll}
      handleDelete={handleDeleteItem}
    />
  );
};
